<template>
  <div>
    <botao-voltar text="Voltar" :route="this.$store.state.paciente.rotaOrigem"/>
    <paciente-ficha-cabecalho :paciente="dadosGerais"/>
    <div class="pb-5">
      <v-tabs class="container-tabs">
        <v-tab v-for="(aba, index) in rotas" :key="index" :to="construirRota(aba.nomeRota)"
               active-class="v-tabs__item--active secondary--text">
          {{ aba.titulo }}
        </v-tab>
      </v-tabs>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import BotaoVoltar from '@/views/components/BotaoVoltar.vue'
import PacienteFichaCabecalho from '@/views/pages/cadastros/paciente/comum/PacienteFichaCabecalho.vue'
import {mapMutations} from 'vuex'
import {actionTypes, mutationTypes} from '@/core/constants'

export default {
    name: 'PacienteComum',
    components: {PacienteFichaCabecalho, BotaoVoltar},
    data() {
        return {
            pacienteId: null,
            dadosGerais: {
                nome: null,
                cidade: null,
                estado: null,
            },
            rotas: [{
                titulo: 'Ficha',
                nomeRota: 'PacienteFicha'
            },
            {
                titulo: 'Atendimentos',
                nomeRota: 'PacienteAtendimento'
            },
            {
                titulo: 'Orçamentos',
                nomeRota: 'PacienteOrcamento'
            },
            {
                titulo: 'Cobranças',
                nomeRota: 'PacienteCobrancas'
            },
            {
                titulo: 'Galeria',
                nomeRota: 'PacienteGaleria'
            },
            ]
        }
    },
    async beforeMount() {
        this.setarPacienteId()
        this.setarRotaOrigem()
        await this.buscarPaciente()
    },
    methods: {
        ...mapMutations([mutationTypes.CADASTROS.PACIENTE.SET_ROTA_ORIGEM]),
        setarPacienteId() {
            if (this.$route.params.id) {
                this.pacienteId = this.$route.params.id
            }
        },
        setarRotaOrigem() {
            this.setRotaOrigem({name: 'PacienteListagem'})
        },
        async buscarPaciente() {
            const resposta = await this.$store.dispatch(actionTypes.CADASTROS.PACIENTE.BUSCAR_PACIENTE_POR_ID, this.pacienteId)
            if (resposta) {
                this.dadosGerais = resposta
                this.$store.commit(mutationTypes.DRAWER.SET_ASIDE, true)
            }
        },
        construirRota(name) {
            return {
                name,
                params: {id: this.pacienteId},
                query: this.$route.query
            }
        },
    }
}
</script>

<style scoped lang="stylus">

</style>